import React from "react";
import {
  FiCalendar,
  FiClock,
  FiMapPin,
  FiExternalLink,
} from "react-icons/fi";
import "./Schedules.css";

/* ── Static schedule data ───────────────────────────────────────── */
const PROGRAMME = [
  {
    time: "09:00 – 10:00",
    event: "Registration & Kit Collection",
    location: "Registration Desk, Ground Floor, Sir Jagadish Chandra Bose Academic Building",
    icon: "📋",
  },
  {
    time: "10:00 – 10:45",
    event: "Inauguration Ceremony",
    location: "Professor Md. Shorif Hossain Gallery, Jatiyo Kobi Kazi Nazrul Islam Academic Building",
    icon: "🎓",
  },
  {
    time: "10:45 – 11:45",
    event: "Keynote Sessions",
    location: "Professor Md. Shorif Hossain Gallery",
    icon: "🎤",
  },
  {
    time: "11:45 – 12:00",
    event: "Tea Break & Snacks",
    location: "2nd Floor, Sir Jagadish Chandra Bose Academic Building",
    icon: "☕",
  },
  {
    time: "12:00 – 13:15",
    event: "Morning Technical Sessions",
    location: "5 Parallel Sessions (Various Rooms)",
    icon: "📑",
  },
  {
    time: "13:15 – 14:45",
    event: "Prayer & Lunch Break",
    location: "1st Floor, Sir Jagadish Chandra Bose Academic Building",
    icon: "🍽️",
  },
  {
    time: "14:45 – 16:00",
    event: "Afternoon Technical Sessions & Poster Session",
    location: "Parallel Sessions & 1st Floor, Sir Jagadish Chandra Bose Academic Building",
    icon: "📊",
  },
  {
    time: "16:00 – 16:30",
    event: "Tea & Refreshment",
    location: "2nd Floor, Sir Jagadish Chandra Bose Academic Building",
    icon: "🧁",
  },
  {
    time: "16:30 – 17:00",
    event: "Award Ceremony",
    location: "Professor Md. Shorif Hossain Gallery",
    icon: "🏆",
  },
  {
    time: "19:00 – 20:00",
    event: "Gala Dinner",
    location: "3rd & 4th Floor, Teachers and Students Centre (TSC)",
    icon: "🎉",
  },
];

const FULL_SCHEDULE_URL =
  "https://drive.google.com/file/d/1FEDWtHXUKxEeTznq6_sqJBBjUA_0j2Gd/view?usp=sharing";

/* ── Component ───────────────────────────────────────────────────── */
const Schedule = () => {
  return (
    <div className="schedule-container">
      {/* ── Header ── */}
      <div className="schedule-header">
        <div className="heading-container">
          <h1>Program Schedule</h1>
        </div>
        <p className="schedule-subtitle">
          <FiCalendar style={{ marginRight: "0.4rem", verticalAlign: "middle" }} />
          15 May 2026 &nbsp;|&nbsp;
          <FiMapPin style={{ marginRight: "0.4rem", verticalAlign: "middle" }} />
          Sir Jagadish Chandra Bose Academic Building, JUST
        </p>
      </div>

      {/* ── Programme at a Glance ── */}
      <div className="glance-wrapper">
        <div className="glance-card">
          <div className="glance-title-row">
            <span className="glance-badge">Programme at a Glance</span>
          </div>

          <div className="glance-table">
            {PROGRAMME.map((row, idx) => (
              <div
                key={idx}
                className={`glance-row ${idx % 2 === 0 ? "glance-row-even" : "glance-row-odd"}`}
              >
                {/* Time column */}
                <div className="glance-time">
                  <FiClock className="glance-icon" />
                  <span>{row.time}</span>
                </div>

                {/* Event column */}
                <div className="glance-event">
                  <span className="glance-event-emoji">{row.icon}</span>
                  <span className="glance-event-name">{row.event}</span>
                </div>

                {/* Location column */}
                <div className="glance-location">
                  <FiMapPin className="glance-icon" />
                  <span>{row.location}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Full schedule button ── */}
      <div className="schedule-cta">
        <p className="cta-hint">
          For detailed session papers, chairs, and poster listings, download the full programme:
        </p>
        <a
          href={FULL_SCHEDULE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="full-schedule-btn"
          id="view-full-schedule-btn"
        >
          <FiExternalLink className="cta-icon" />
          View Full Schedule
        </a>
      </div>
    </div>
  );
};

export default Schedule;